import { FaChevronRight } from "react-icons/fa";
import {
  LuLayoutDashboard,
  LuClipboardList,
  LuBuilding2,
} from "react-icons/lu";
import { MdOutlineAssessment, MdAssessment } from "react-icons/md";
import { LiaHandHoldingUsdSolid } from "react-icons/lia";
import { FaClipboardList } from "react-icons/fa6";
import { FaHandHoldingUsd } from "react-icons/fa";
import { PiMoneyWavyFill, PiMoneyWavyBold } from "react-icons/pi";
import {
  HiOutlinePresentationChartBar,
  HiPresentationChartBar,
} from "react-icons/hi";
import { BsCashCoin, BsFillBarChartFill } from "react-icons/bs"; // Added BsFillBarChartFill
import { IoIosCash } from "react-icons/io";
import { IoBarChart } from "react-icons/io5";
import { checkPermissions } from "../../utils/getRolesAndPermissions";

const getFinancialOverviewItems = () => {
  const items = [
    checkPermissions("DASHBOARD", true) && {
      id: 11,
      label: "Dashboard",
      activeIcon: (
        <LuLayoutDashboard className="text-lg scale-95 text-black/70" />
      ),
      icon: (
        <LuLayoutDashboard className="text-lg fill-current scale-95 text-black/70" />
      ),
      path: "/dashboard",
    },
  ].filter(Boolean);

  return items.length > 0
    ? {
        id: 1,
        category: "Financial Overview",
        items,
      }
    : null;
};

const getInvestmentItems = () => {
  const items = [
    (() => {
      const subItems = [
        checkPermissions("FD_MEMO", true) && {
          id: 211,
          label: "Fixed Deposit Memo",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/fd/memo",
        },
        checkPermissions("FD", true) && {
          id: 212,
          label: "Fixed Deposit",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/fd/fixed-deposit",
        },
      ].filter(Boolean);

      return subItems.length > 0
        ? {
            id: 21,
            label: "Fixed Deposit",
            activeIcon: <BsCashCoin className="text-lg text-black/70" />,
            icon: <IoIosCash className="text-lg text-black/70" />,
            path: "/fd",
            subcategory: subItems,
          }
        : null;
    })(),
    (() => {
      const subItems = [
        checkPermissions("SHARE_MEMO", true) && {
          id: 221,
          label: "Shares Memo",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/share/memo",
        },
        checkPermissions("SHARE", true) && {
          id: 222,
          label: "Shares",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/share/shares",
        },
      ].filter(Boolean);

      return subItems.length > 0
        ? {
            id: 22,
            label: "Shares",
            activeIcon: (
              <MdOutlineAssessment className="text-lg scale-110 text-black/70" />
            ),
            icon: <MdAssessment className="text-lg scale-110 text-black/70" />,
            path: "/share",
            subcategory: subItems,
          }
        : null;
    })(),
    (() => {
      const subItems = [
        checkPermissions("DEBENTURE_MEMO", true) && {
          id: 231,
          label: "Debenture Memo",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/debenture/memo",
        },
        checkPermissions("DEBENTURE", true) && {
          id: 232,
          label: "Debenture",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/debenture/debentures",
        },
      ].filter(Boolean);

      return subItems.length > 0
        ? {
            id: 23,
            label: "Debenture",
            activeIcon: (
              <LiaHandHoldingUsdSolid className="text-lg scale-125 text-black/70" />
            ),
            icon: (
              <FaHandHoldingUsd className="text-lg scale-110 fill-current text-black/70" />
            ),
            path: "/debenture",
            subcategory: subItems,
          }
        : null;
    })(),
    (() => {
      const subItems = [
        checkPermissions("GOVERNMENT_BOND_VIEW_MEMO", true) && {
          id: 233,
          label: "Government Bond Memo",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/government-bond/memo",
        },
        checkPermissions("GOVERNMENT_BOND_VIEW", true) && {
          id: 234,
          label: "Government Bond",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/government-bond/bonds",
        },
      ].filter(Boolean);

      return subItems.length > 0
        ? {
            id: 27,
            label: "Government Bond",
            activeIcon: (
              <LiaHandHoldingUsdSolid className="text-lg scale-125 text-black/70" />
            ),
            icon: (
              <FaHandHoldingUsd className="text-lg scale-110 fill-current text-black/70" />
            ),
            path: "/government-bond",
            subcategory: subItems,
          }
        : null;
    })(),
    (() => {
      const subItems = [
        checkPermissions("MUTUALFUND_MEMO", true) && {
          id: 241,
          label: "Mutual Fund Memo",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/fund/memo",
        },
        checkPermissions("MUTUALFUND", true) && {
          id: 242,
          label: "Mutual Fund",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/fund/mutual-funds",
        },
      ].filter(Boolean);

      return subItems.length > 0
        ? {
            id: 24,
            label: "Mutual Fund",
            activeIcon: <IoBarChart className="text-lg text-black/70" />,
            icon: <IoBarChart className="text-lg fill-current text-black/70" />,
            path: "/fund",
            subcategory: subItems,
          }
        : null;
    })(),
    (() => {
      const subItems = [
        checkPermissions("PREFERENCE_SHARE_MEMO", true) && {
          id: 251,
          label: "Preference Share Memo",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/pref-share/memo",
        },
        checkPermissions("PREFERENCE_SHARE_VIEW", true) && {
          id: 252,
          label: "Preference Share",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/preference-share",
        },
      ].filter(Boolean);

      return subItems.length > 0
        ? {
            id: 25,
            label: "Preference Share",
            activeIcon: (
              <BsFillBarChartFill className="text-lg text-black/70" />
            ), // Changed here
            icon: <BsFillBarChartFill className="text-lg text-black/70" />, // Changed here
            path: "/preference-share",
            subcategory: subItems,
          }
        : null;
    })(),
  ].filter(Boolean);

  return items.length > 0
    ? {
        id: 2,
        category: "Investments",
        items,
      }
    : null;
};

const getAlternativeInvestmentItems = () => {
  const items = [
    (() => {
      const subItems = [
        checkPermissions("ALT_INVESTMENT_VIEW_OVERVIEW", true) && {
          id: 416,
          label: "PEVC Companies",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/alt-inv/pevc-companies",
        },
        checkPermissions("ALT_INVESTMENT_VIEW_OVERVIEW", true) && {
          id: 411,
          label: "Dashboard",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/alt-inv/pevc-dashboard",
          exact: true,
        },
        checkPermissions("ALT_INVESTMENT_VIEW_OVERVIEW", true) && {
          id: 412,
          label: "Fund Summary",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/alt-inv/fund-summary",
        },
        checkPermissions("ALT_INVESTMENT_VIEW_OVERVIEW", true) && {
          id: 413,
          label: "Investment Details",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/alt-inv/investment-details",
        },
        checkPermissions("ALT_INVESTMENT_VIEW_OVERVIEW", true) && {
          id: 414,
          label: "Portfolio Financials",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/alt-inv/portfolio-financials",
        },
        checkPermissions("ALT_INVESTMENT_VIEW_OVERVIEW", true) && {
          id: 415,
          label: "Fund Financials",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/alt-inv/fund-financials",
        },
      ].filter(Boolean);

      return subItems.length > 0
        ? {
            id: 41,
            label: "PEVC",
            activeIcon: (
              <HiPresentationChartBar className="text-lg fill-current text-black/70" />
            ),
            icon: (
              <HiOutlinePresentationChartBar className="text-lg text-black/70" />
            ),
            path: "/alt-inv/pevc-dashboard",
            subcategory: subItems,
          }
        : null;
    })(),
    (() => {
      const subItems = [
        checkPermissions("ALT_INVESTMENT_VIEW_OVERVIEW", true) && {
          id: 421,
          label: "Nepal Life Capital",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/alt-inv/capital-company",
          activePaths: [
            "/alt-inv/capital-company",
            "/alt-inv/capital-dashboard",
            "/alt-inv/investment-portfolio",
          ],
        },
        checkPermissions("ALT_INVESTMENT_VIEW_OVERVIEW", true) && {
          id: 422,
          label: "Nepal Life Investment",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          subcategory: [
            checkPermissions("ALT_INVESTMENT_VIEW_OVERVIEW", true) && {
              id: 4221,
              label: "Overview",
              activeIcon: (
                <FaChevronRight className="text-xs -mr-2 text-black/70" />
              ),
              icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
              path: "/alt-inv/investment-company",
              exact: true,
            },
            checkPermissions("ALT_INVESTMENT_VIEW_OVERVIEW", true) && {
              id: 4222,
              label: "Hydropower",
              activeIcon: (
                <FaChevronRight className="text-xs -mr-2 text-black/70" />
              ),
              icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
              path: "/alt-inv/investment-company/hydropower",
            },
            checkPermissions("ALT_INVESTMENT_VIEW_OVERVIEW", true) && {
              id: 4223,
              label: "Hospitality",
              activeIcon: (
                <FaChevronRight className="text-xs -mr-2 text-black/70" />
              ),
              icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
              path: "/alt-inv/investment-company/hospitality",
            },
          ].filter(Boolean),
        },
      ].filter(Boolean);

      return subItems.length > 0
        ? {
            id: 42,
            label: "Company Overview",
            activeIcon: <LuBuilding2 className="text-lg text-black/70" />,
            icon: <LuBuilding2 className="text-lg text-black/70" />,
            path: "/alt-inv/company-overview",
            subcategory: subItems,
          }
        : null;
    })(),
  ].filter(Boolean);

  return items.length > 0
    ? {
        id: 4,
        category: "Alternative Investment",
        items,
      }
    : null;
};

const getReportsDirectivesItems = () => {
  const items = [
    checkPermissions("REPORTS", true) && {
      id: 31,
      label: "Reports",
      activeIcon: <LuClipboardList className="text-lg text-black/70" />,
      icon: <FaClipboardList className="text-lg fill-current text-black/70" />,
      path: "/reports",
      subcategory: [
        checkPermissions("REPORTS_ALL", true) && {
          id: 311,
          label: "Reports",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/reports/all",
        },
        checkPermissions("REPORTS_SHARE", true) && {
          id: 312,
          label: "Share Reports",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/reports/report-share",
        },
        checkPermissions("REPORTS_DEBENTURE", true) && {
          id: 315,
          label: "Debenture Reports",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/reports/report-debenture",
        },
        checkPermissions("REPORTS_GOVERNMENT_BOND", true) && {
          id: 316,
          label: "Gov Bond Reports",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/reports/report-gov-bond",
        },
        checkPermissions("REPORTS_MUTUAL_FUND", true) && {
          id: 317,
          label: "Mutual Fund Reports",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/reports/report-mutual-fund",
        },
        checkPermissions("REPORTS_PREFERENCE_SHARE", true) && {
          id: 318,
          label: "Pref Share Reports",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/reports/report-pref-share",
        },
        checkPermissions("ENTRY_BOOK", true) && {
          id: 313, // Fixed duplicate ID issue - changed from 312 to 313
          label: "Entry Book",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/reports/entry-book",
        },
        checkPermissions("REPORT_ALT_INV", true) && {
          id: 314,
          label: "Alternative Report",
          activeIcon: (
            <FaChevronRight className="text-xs -mr-2 text-black/70" />
          ),
          icon: <FaChevronRight className="text-xs -mr-2 text-black/70" />,
          path: "/reports/alternative-investment-report",
        },
      ].filter(Boolean),
    },
    checkPermissions("INTEREST_ACCRUED", true) && {
      id: 32,
      label: "Interest Accrued",
      activeIcon: (
        <PiMoneyWavyBold className="text-lg scale-110 text-black/70" />
      ),
      icon: <PiMoneyWavyFill className="text-lg scale-110 text-black/70" />,
      path: "/interestaccrued",
    },
    checkPermissions("INVESTMENT_DIRECTIVES", true) && {
      id: 33,
      label: "Investment Directives",
      activeIcon: (
        <HiOutlinePresentationChartBar className="text-lg scale-110 text-black/70" />
      ),
      icon: (
        <HiPresentationChartBar className="text-lg scale-110 text-black/70" />
      ),
      path: "/directives",
    },
  ].filter(Boolean);

  return items.length > 0
    ? {
        id: 3,
        category: "Reports & Directives",
        items,
      }
    : null;
};

const navItems = [
  getFinancialOverviewItems(),
  getInvestmentItems(),
  getAlternativeInvestmentItems(),
  getReportsDirectivesItems(),
].filter(Boolean); // Remove any null categories

export const getFirstPermittedRoute = () => {
  const dynamicNavItems = [
    getFinancialOverviewItems(),
    getInvestmentItems(),
    getAlternativeInvestmentItems(),
    getReportsDirectivesItems(),
  ].filter(Boolean);

  const findFirstPath = (list) => {
    for (const el of list) {
      if (el.subcategory && el.subcategory.length > 0) {
        const found = findFirstPath(el.subcategory);
        if (found) return found;
      } else if (el.path) {
        return el.path;
      }
    }
    return null;
  };

  for (const section of dynamicNavItems) {
    const found = findFirstPath(section.items);
    if (found) return found;
  }
  return "/dashboard";
};

export default navItems;
